// extracted by mini-css-extract-plugin
export var downArrow = "_88-0";
export var label = "_88-1";
export var treatmentCard = "_88-3";
export var upArrow = "_88-2";